module.exports = __webpack_public_path__ + "static/img/banner.78cedd0e.jpg";